import { render, staticRenderFns } from "./StockBorraDetail.vue?vue&type=template&id=76d5977c&scoped=true"
import script from "./StockBorraDetail.vue?vue&type=script&lang=js"
export * from "./StockBorraDetail.vue?vue&type=script&lang=js"
import style0 from "./StockBorraDetail.vue?vue&type=style&index=0&id=76d5977c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d5977c",
  null
  
)

export default component.exports